import { baseApi } from './baseApi';
import { ServiceTypes } from '../constants';
import { BlockFromApi } from '../interfaces';
import { Block, mapBlockToStore } from './micrositeTemplates.service';

export const blocksService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBlock: builder.query<Block, void>({
      query: (blockId) => `/blocks/${blockId}`,
      transformResponse: (result: { data: BlockFromApi }) => mapBlockToStore(result.data),
      providesTags: (result) => (result ? [{ type: ServiceTypes.BLOCKS, id: 'LIST_BLOCKS' }] : []),
    }),
    getBlocks: builder.query<Block[], void>({
      query: () => `/blocks?type=block`,
      transformResponse: (result: { data: BlockFromApi[] }) =>
        result.data
          .map(mapBlockToStore)
          .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()),
      providesTags: (result) => (result ? [{ type: ServiceTypes.BLOCKS, id: 'LIST_BLOCKS' }] : []),
    }),
    getLayouts: builder.query<Block[], void>({
      query: () => `/blocks?type=layout`,
      transformResponse: (result: { data: BlockFromApi[] }) =>
        result.data
          .map(mapBlockToStore)
          .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()),
      providesTags: (result) => (result ? [{ type: ServiceTypes.BLOCKS, id: 'LIST_LAYOUTS' }] : []),
    }),
  }),
});

export const {
  // queries
  useGetBlockQuery,
  useGetLayoutsQuery,
  useGetBlocksQuery,
} = blocksService;
